import { useInvestProperties } from "components/hooks";
import { Redirect, Route } from "react-router-dom";
import { Routes } from "../../../../const";

const InvestorPropertyRoute = ({
  component: Component, location, condition, ...rest
}) => {
  const valid = useInvestProperties()
  return (
    <Route {...rest}
      render={props =>
        valid
          ? <Component {...props} />
          : <Redirect to={{ pathname: Routes.Disclaimer, state: { from: location } }} />}
    />
  )
}

export default InvestorPropertyRoute;